import { render, staticRenderFns } from "./CustomerDeposit.vue?vue&type=template&id=add450c6&scoped=true&"
import script from "./CustomerDeposit.vue?vue&type=script&lang=js&"
export * from "./CustomerDeposit.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDeposit.vue?vue&type=style&index=0&id=add450c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add450c6",
  null
  
)

export default component.exports